import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import 'firebase/auth';
import { initialValues, useFormHoc, validationSchema } from './form-hoc';
import { Form, Formik, useFormikContext } from 'formik';
import styled from 'styled-components';
import faviconSvg from 'shared/icons/favicon.svg';
import ReactGA from 'react-ga';
import { Container } from './styles';
import { Flex } from 'rebass';
import { FormControl } from 'shared/components/form/control';
import { Alert, Button, Typography } from 'antd';
import PropTypes from 'prop-types';
import { Loader } from 'shared/components/spinner';
import { colors } from 'shared/styles/settings';
import Label from 'shared/components/label';
import { useQueryStrings } from 'shared/hooks/query-strings';
import Text from 'shared/components/text';
import { firebaseApp } from 'shared/firebase';
import { environments } from 'shared/utils/environments';

const { Title } = Typography;
const Logo = styled(faviconSvg)`
  height: 40px;
`;

function AuthForm({ error }) {
  const { params } = useQueryStrings();
  const { isSubmitting } = useFormikContext();

  return (
    <Form>
      {isSubmitting && <Loader />}
      <Flex bg={colors.background} justifyContent="center" alignItems="center" height="100vh">
        <Container columns={1}>
          <Flex flexDirection="column" alignItems="center" mb={12}>
            <Logo />
            <Title style={{ lineHeight: 1, marginTop: 12, marginBottom: 8 }} level={2}>
              Admin Platform
            </Title>
            <Label mb={2}>Sign into your account</Label>
            {params.has('custom_token') && (
              <Alert
                message={
                  <Text>
                    If you are a vendor, please use Vendor Portal. Click{' '}
                    <Typography.Link href={`${environments.vendorUrl}/auth?token=${params.get('custom_token')}`}>
                      Here
                    </Typography.Link>{' '}
                    to login
                  </Text>
                }
                type="warning"
              />
            )}
            {error && <Alert message={error} type="error" />}
          </Flex>
          <FormControl px={0} name="email" placeholder="Email" settings={{ type: 'email' }} />
          <FormControl px={0} name="password" placeholder="Password" settings={{ type: 'password' }} />
          <Button style={{ width: '100%', marginTop: 8 }} type="primary" htmlType="submit">
            Login
          </Button>
        </Container>
      </Flex>
    </Form>
  );
}

AuthForm.propTypes = {
  error: PropTypes.string,
};

export default function Auth() {
  const { error, handleSubmit } = useFormHoc();
  const location = useLocation();

  useEffect(() => {
    firebaseApp.auth().signOut();
    ReactGA.pageview(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
      <AuthForm error={error} />
    </Formik>
  );
}
